import axios from 'axios';

class WebNodeHelper {
	constructor() {
		let search = '';
		try {
			search = window.top.location.search;
		} catch (err) {
			search = window.location.search;
		}
		// const { webnode } = queryString.parse(search.toLowerCase());
		const webnode = 'prd';
		this.webNodeBaseUrl = (() => {
			switch (webnode) {
				case 'local':
					return 'http://localhost:3000';
				case 'dev':
					return 'https://webnodedev.esri.com';
				case 'stg':
					return 'https://webnodestg.esri.com';
				default:
					return 'https://webnode.esri.com';
			}
		})();
	}

	async recordFormLoad(analyticsProps) {
		try {
			const response = await axios.post(`${this.webNodeBaseUrl}/3014/pardot_form_api/recordFormLoad`, analyticsProps);
			return response.data || '';
		} catch (err) {
			return '';
		}
	}

	async recordFormStart(analyticsProps) {
		try {
			const response = await axios.post(`${this.webNodeBaseUrl}/3014/pardot_form_api/recordFormStart`, analyticsProps);
			return response.data || '';
		} catch (err) {
			return '';
		}
	}

	async recordFormSubmit(analyticsProps) {
		try {
			const response = await axios.post(`${this.webNodeBaseUrl}/3014/pardot_form_api/recordFormSubmit`, analyticsProps);
			return response.data || '';
		} catch (err) {
			return '';
		}
	}

	async submitToPardot(formData) {
		try {
			const response = await axios.post(`${this.webNodeBaseUrl}/3014/pardot_form_api/submitForm`, formData);
			return response.data || '';
		} catch (err) {
			return '';
		}
	}
}

export default new WebNodeHelper();
